<template>
<div>
    <div>
        <el-form :inline="true">
            <!--  <el-form-item label="阶段">
                    <el-select v-model="stageValue" placeholder="请选择">
                        <el-option v-for="item in stage" :key="item.value" :label="item.label" :value="item.value">
                        </el-option>
                    </el-select>
                </el-form-item> -->
            <el-form-item label="级数">
                <el-select style="margin-left: 10px;" v-model="gradesValue" placeholder="请选择" width="500">
                    <el-option v-for="item in grades" :key="item.id" :label="item.name" :value="item.id">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="天数">
                <el-select style="margin-left: 10px;" v-model.number="anyDay" placeholder="请选择" width="500">
                    <el-option v-for="item in anyDays" :key="item" :label="item" :value="item">
                    </el-option>
                </el-select>
            </el-form-item>
            <!--  <el-form-item label="阶段">
                    <el-select style="margin-left: 10px;" v-model="gradeClassify" placeholder="请选择" width="500">
                        <el-option v-for="item in gradeClassifies" :key="item" :label="item" :value="item">
                        </el-option>
                    </el-select>
                </el-form-item> -->
            <el-form-item label="题型">
                <el-select style="margin-left: 10px;" v-model="questionTypesValue" placeholder="请选择" width="500">
                    <el-option v-for="item in questionTypes" :key="item.id" :label="item.name" :value="item.id">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="第几道题">
                <el-select style="margin-left: 10px;" v-model.number="indexInOneDay" placeholder="请选择" width="500">
                    <el-option v-for="item in indexInOneDays" :key="item" :label="item" :value="item">
                    </el-option>
                </el-select>
            </el-form-item>

            <el-form-item>
                <el-button style="margin-left: 10px;" type="primary" @click="fetchData(1)">按最后更新日期查询</el-button>
            </el-form-item>
            <el-form-item>
                <el-button style="margin-left: 10px;" type="primary" @click="fetchData2(1)">按题目排序查询</el-button>
            </el-form-item>
        </el-form>
    </div>
    <el-table :data="questions" style="width: 100%;margin-top: 50px;">
        <!--  <el-table-column type="index" width="80">
            </el-table-column> -->
        <el-table-column prop="indexInOneDay" label="当天顺序" width="100">
            <template slot-scope="scope">
                <el-input v-model.number="scope.row.indexInOneDay" placeholder="从1开始"></el-input>
            </template>
        </el-table-column>
        <el-table-column prop="questionTypeStr" label="题型" width="150">

        </el-table-column>
        <el-table-column label="题干">
            <!--  <template slot-scope="scope">
                    <div style="word-wrap: break-word;">
                        {{scope.row.sn}} . {{scope.row.intro}}
                    </div>
                    <div> <img  v-if="scope.row.image"  style="max-width: 50px;
    height: 50px;" v-bind:src=" scope.row.image.url"></div>
                    <div>
                        <audio  style="width: 220px;height: 50px;" v-if="scope.row.voice" :src="scope.row.voice.url" controls="controls">
                        </audio>
                    </div>
                </template> -->
            <el-table-column property="intro" label="文本" width="200">
            </el-table-column>
            <el-table-column property="image" label="图片" width="100">
                <template slot-scope="scope">
                    <img v-if="scope.row.image" style="width: 50px;height:50px;" :src=" scope.row.image.url"></img>
                </template>
            </el-table-column>
            <el-table-column property="voice" label="语音" width="200">
                <!--    
                      <el-table-column property="voice.name" label="文本" width="300">
                     </el-table-column> -->
                <!--    <template slot-scope="scope">
                           <span >scope.row.voice.name</span>
                        <audio style="width: 220px;height: 50px;" v-if="scope.row.voice" :src="scope.row.voice.url" controls="controls">
                        </audio>
                    </template> -->
            </el-table-column>
        </el-table-column>
        <el-table-column label="操作">
            <template slot-scope="scope">
                <el-button size="mini" type="success" @click="handleSave(scope.$index, scope.row)">保存排序</el-button>
                <el-button size="mini" @click="handleCopy(scope.$index, scope.row)">复用</el-button>

                <el-button size="mini" @click="handleEdit(scope.$index, scope.row)">编辑</el-button>
                <el-button size="mini" type="danger" @click="handleDelete(scope.$index, scope.row)">删除</el-button>
            </template>
        </el-table-column>
    </el-table>
    <div class="block" style="float: right;margin:30px;">
        <el-pagination :current-page="questionCurrentPage" :page-size="pageSize" @current-change="handleCurrentChange" layout="prev, pager, next" :total="counts">
        </el-pagination>
    </div>
</div>
</template>

<script>
import AV from 'leancloud-storage'

import Question from '../../model/question'
import Grade from '../../model/grade'
import QuestionType from '../../model/questionType'

export default {
    data() {
        return {
            pageSize: 5,
            questionCurrentPage: 1,
            questionTypes: [],
            grades: [],
            stage: [{
                    value: 'all',
                    label: '全部'
                },
                {
                    value: 'initiation',
                    label: '启蒙课程'
                },
                {
                    value: '1',
                    label: '基础课程'
                },
                {
                    value: '2',
                    label: '进阶课程'
                },
                {
                    value: '3',
                    label: '提高课程'
                }
            ],
            stageValue: 'all',
            questionTypesValue: '',
            gradesValue: '',

            gradeClassifies: ['initiation', '1', '2', '3'],

            gradeClassify: 'initiation',
            anyDay: '全部',
            indexInOneDay: '全部',
            anyDays: [],
            indexInOneDays: [],

            questions: [],
            questionsAV: [],
            counts: 0
        }
    },

    created() {
        this.getData()
    },

    methods: {
        formatClassify(str) {
            switch (str) {
                case 'initiation':
                    return '启蒙课程'
                case '1':
                    return '基础课程'
                case '2':
                    return '进阶课程'
                case '3':
                    return '提高课程'
            }
        },
        getData() {
            this.anyDays.push('全部')
            this.indexInOneDays.push('全部')
            for (let i = 0; i < 100; i++) {
                this.anyDays.push(i + 1)
                this.indexInOneDays.push(i + 1)
            }

            if (localStorage.anyDay) {
                this.anyDay = localStorage.anyDay
            }

            if (localStorage.indexInOneDay) {
                this.indexInOneDay = localStorage.indexInOneDay
            }

            // this.fetchData()
            new AV.Query(QuestionType)
                .descending('series')
                .find()
                .then(questionTypes => {
                    this.questionTypes = questionTypes
                    this.questionTypesAV = questionTypes

                    this.questionTypes.unshift({
                        id: '',
                        name: '全部'
                    })

                    if (localStorage.questionTypesValue) {
                        this.questionTypesValue = localStorage.questionTypesValue
                    }
                })
            let that = this
            new AV.Query(Grade)
                .ascending('series')
				.limit(1000)
                .find()
                .then(grades => {
                    this.gradesAV = grades
                    // this.grades = grades;

                    this.grades.push({
                        id: '',
                        name: '全部'
                    })
                    for (let i = 0; i < grades.length; i++) {
                        //   console.log(grades[i].index)
                        this.grades.push({
                            id: grades[i].id,
                            name: grades[i].series + ' - ' + grades[i].name + ' - ' + grades[i].classify
                        })
                    }

                    if (localStorage.gradesValue) {
                        this.gradesValue = localStorage.gradesValue
                    }
                })
        },
        fetchData2(pageTemp) {
            this.queryType = 2;
            if(pageTemp==1){
                this.questionCurrentPage=pageTemp
            }
            let query = new AV.Query(Question)
                .include('grade')                
                .include('questionType')
                .limit(this.pageSize)
                .skip((this.questionCurrentPage - 1) * this.pageSize)

            if (this.questionTypesValue.length > 0) {
                for (let i = 0; i < this.questionTypesAV.length; i++) {
                    if (this.questionTypesValue == this.questionTypesAV[i].id) {
                        query.equalTo('questionType', this.questionTypesAV[i])
                    }
                }
            } 

            if (this.gradesValue.length > 0) { 
                //  console.log(this.gradesValue );
                for (let i = 0; i < this.gradesAV.length; i++) {
                    if (this.gradesValue == this.gradesAV[i].id) {
                        // console.log(111);
                        query.equalTo('grade', this.gradesAV[i])
                    }
                }
            }

            if (this.anyDay != '全部') {
                query.equalTo('anyDay', Number(this.anyDay))
            }

            if (this.indexInOneDay != '全部') {
                query.equalTo('indexInOneDay', Number(this.indexInOneDay))
            }

            query.count().then(c => {
                this.counts = c
            })

            // console.log(query);

            // console.log(query)

            //保存上次的查询条件
            localStorage.anyDay = this.anyDay
            localStorage.indexInOneDay = this.indexInOneDay
            localStorage.gradesValue = this.gradesValue
            localStorage.questionTypesValue = this.questionTypesValue

            console.log(localStorage);
            query.addAscending('questionType.series')
            query.ascending('indexInOneDay')
                // .addDescending('updatedAt')
                // .addDescending('indexInOneDay')
				
                .find()
                .then(questions => {
                    //              questions.sort(function (a, b) {
                    //   return a.questionType.series - b.questionType.series;
                    // })
                    // questions.sort(function (a, b) {
                    //   return a.indexInOneDay - b.indexInOneDay;
                    // })
                    this.questionsAV = questions
                    // console.log(questions.length);

                    // this.questions = questions;
                    this.questions = []
                    // questions.sort(function(a,b){
                    //   return a.indexInOneDay-b.indexInOneDay
                    // })
                    for (let i = 0; i < questions.length; i++) {
                        // console.log(questions[i]);
                        this.questions.push({
                            id: questions[i].id,
                            indexInOneDay: questions[i].indexInOneDay,
                            questionTypeStr: questions[i].questionType.name,
                            intro: questions[i].questionData[0][0].intro,
                            image: questions[i].questionData[0][0].image,
                            voice: questions[i].questionData[0][0].voice.name
                        })
                    }
                })
                .catch(err => {
                    console.log(err)
                })
        },
        fetchData(pageTemp) {
            console.log(pageTemp)
            this.queryType = 1;
             if(pageTemp==1){
                this.questionCurrentPage=pageTemp
            }
            let query = new AV.Query(Question)
                .include('grade')
                .include('questionType')
                .limit(this.pageSize)
                .skip((this.questionCurrentPage - 1) * this.pageSize)

            if (this.questionTypesValue.length > 0) {
                for (let i = 0; i < this.questionTypesAV.length; i++) {
                    if (this.questionTypesValue == this.questionTypesAV[i].id) {
                        query.equalTo('questionType', this.questionTypesAV[i])
                    }
                }
            }

            if (this.gradesValue.length > 0) {
                //  console.log(this.gradesValue );
                for (let i = 0; i < this.gradesAV.length; i++) {
                    if (this.gradesValue == this.gradesAV[i].id) {
                        // console.log(111);
                        query.equalTo('grade', this.gradesAV[i])
                    }
                }
            }

            if (this.anyDay != '全部') {
                query.equalTo('anyDay', Number(this.anyDay))
            }

            if (this.indexInOneDay != '全部') {
                query.equalTo('indexInOneDay', Number(this.indexInOneDay))
            }

            query.count().then(c => {
                this.counts = c
            })


            // console.log(query)

            //保存上次的查询条件
            localStorage.anyDay = this.anyDay
            localStorage.indexInOneDay = this.indexInOneDay
            localStorage.gradesValue = this.gradesValue
            localStorage.questionTypesValue = this.questionTypesValue

            console.log(localStorage);
            query.descending('updatedAt')
                // .addDescending('updatedAt')
                // .addDescending('indexInOneDay')

                .find()
                .then(questions => {
                    this.questionsAV = questions
                    // console.log(questions.length);

                    // this.questions = questions;
                    this.questions = []
                    // questions.sort(function(a,b){
                    //   return a.indexInOneDay-b.indexInOneDay
                    // })
                    for (let i = 0; i < questions.length; i++) {
                        // console.log(questions[i]);
                        this.questions.push({
                            id: questions[i].id,
                            indexInOneDay: questions[i].indexInOneDay,
                            questionTypeStr: questions[i].questionType.name,
                            intro: questions[i].questionData[0][0].intro,
                            image: questions[i].questionData[0][0].image,
                            voice: questions[i].questionData[0][0].voice.name
                        })
                    }
                })
                .catch(err => {
                    console.log(err)
                })
        },

        handleCurrentChange(page) {
            this.questionCurrentPage = page
            if (this.queryType == 1) {
                this.fetchData()
            } else {
                this.fetchData2()
            }

        },

        handleEdit(index, row) {
            this.$router.push({
                path: '/question/add',
                query: {
                    id: row.id
                }
            })
        },
        handleSave(index, row) {
            let question = this.questionsAV[index]

            question.indexInOneDay = row.indexInOneDay

            question.save()
        },
        handleCopy(index, row) {
            this.$router.push({
                path: '/question/add',
                query: {
                    id: row.id,
                    copy: '1'
                }
            })
        },
        handleDelete(index, row) {
            AV.User.current().fetch({
                keys: 'role'
            }).then(r => {
                if (r.get('role') == '1999') {
                    this.$confirm('此操作将永久删除等级, 是否继续?', '提示', {
                            confirmButtonText: '确定',
                            cancelButtonText: '取消',
                            type: 'warning'
                        })
                        .then(() => {
                            this.$message({
                                type: 'success',
                                message: '删除成功!'
                            })

                            this.questionsAV[index]
                                .destroy()
                                .then(() => {
                                    this.questions.splice(index, 1)
                                    this.questionsAV.splice(index, 1)
                                })
                                .catch(err => {
                                    console.log(err)
                                })
                        })
                        .catch(() => {})
                } else {
                    this.$message({
                        type: 'warning',
                        message: '没有权限!'
                    })
                }
            })

        }
    }
}
</script>
